export const CLOSE_SNACKBAR_ERROR = 'CLOSE_SNACKBAR_ERROR';
export const OPEN_SNACKBAR_ERROR = 'OPEN_SNACKBAR_ERROR';

export const openSnackbarError = (errorCode) => ({type: OPEN_SNACKBAR_ERROR, errorCode});
export const closeSnackbarError = () => ({type: CLOSE_SNACKBAR_ERROR});
